import React from "react"
import { Text } from "@chakra-ui/react"
import { Results } from "@usereactify/search"

type Props = Parameters<NonNullable<Parameters<typeof Results>[0]["renderError"]>>[0]

const ProductGridError: React.FC<Props> = () => <Text fontWeight="bold">Error display products</Text>

export default ProductGridError
